
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34077',
  depVersions: {
  "documents-public-ui": "static-1.34077",
  "client-types": "static-1.451",
  "documents-lib": "static-1.34082",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1976",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4884",
  "highcharts": "static-8.100",
  "hs-promise-utils": "static-1.5441",
  "hs-test-utils": "static-1.7854",
  "hub-http": "static-1.6065",
  "hubspot-dlb": "static-2.1806",
  "HubStyleTokens": "static-2.11289",
  "I18n": "static-7.1584",
  "jasmine-immutable": "static-1.2865",
  "jasmine-runner": "static-1.6318",
  "lodash": "static-1.3",
  "quartz": "static-1.6797",
  "react": "static-7.182",
  "react-dlb": "static-1.74",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.67",
  "react-rhumb": "static-1.16498",
  "reporting-data": "static-1.66720",
  "reporting-testing-lib": "static-1.8653",
  "reporting-visualizations": "static-1.58796",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4615",
  "webpack-env": "static-1.54",
  "atom": "static-1.4918",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2340",
  "classnames": "static-2.10",
  "cssUtils": "static-1.749",
  "customer-data-filters-ui": "static-1.39071",
  "customer-data-objects": "static-1.7499",
  "customer-data-property-utils": "static-1.7928",
  "data-fetching-client": "static-1.9525",
  "enviro": "static-4.416",
  "FireAlarmUi": "static-1.4377",
  "flux-actions": "static-1.315",
  "FormsCommonComponents": "static-1.85403",
  "FormUrlGenerator": "static-2.4569",
  "foundations-components": "static-1.7618",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3957",
  "HubStyle": "static-2.11597",
  "icons": "static-2.629",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7007",
  "metrics-js": "static-1.9436",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.377",
  "property-description-translator": "static-1.3704",
  "property-translator": "static-1.5258",
  "quartz-config": "static-1.575",
  "quartz-core": "static-1.6016",
  "quick-fetch": "static-1.3782",
  "raven": "static-3.5768",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5218",
  "react-virtualized": "static-2.95",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8011",
  "reference-resolvers-lite": "static-1.7931",
  "report-customization-components": "static-1.12645",
  "reporting-enablement": "static-1.22245",
  "reporting-reports": "static-1.66398",
  "reporting-snowflake": "static-1.55338",
  "reporting-ui-components": "static-2.63991",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4486",
  "sales-content-partitioning": "static-1.8783",
  "SalesContentIndexUI": "static-3.8974",
  "sanitize": "static-1.4322",
  "sanitize-text": "static-1.7993",
  "self-service-api": "static-1.10090",
  "SharedI18nStrings": "static-1.180",
  "SharedLegalStrings": "static-1.1599",
  "signup-constants": "static-1.18511",
  "signup-ui-lego-core": "static-1.20521",
  "signup-ui-url-generator": "static-2.7882",
  "styled-components": "static-2.85",
  "StyleGuideUI": "static-3.484",
  "superstore": "static-1.4617",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10841",
  "ui-addon-i18n": "static-1.10992",
  "ui-addon-react-router-dom": "static-1.9393",
  "ui-addon-upgrades": "static-9.17724",
  "ui-asset-management-lib": "static-1.10773",
  "ui-images": "static-2.1109",
  "UIComponents": "static-3.8236",
  "usage-tracker": "static-1.7183",
  "usage-tracker-container": "static-1.7173",
  "usage-tracker-core": "static-1.7033",
  "usage-tracker-public": "static-1.6994",
  "viral-links-lib": "static-1.6886",
  "hs-promise-rejection-tracking": "static-1.5433",
  "raven-hubspot": "static-1.6075",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3274",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3074",
  "quartz-webpack": "static-1.3021",
  "ai-components-ui-library": "static-1.8485",
  "amplitude-session-replay-browser": "static-1.56",
  "foundations-assets": "static-1.4687",
  "foundations-theming": "static-1.4260",
  "quartz-auth": "static-1.472",
  "ui-business-units-lib": "static-1.8880",
  "usage-tracker-session-replay": "static-1.4869",
  "foundations-theming-base": "static-1.3245",
  "HeadJS": "static-2.722",
  "framer-motion": "static-1.68",
  "hs-test-utils-bend-plugin": "static-1.2965",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4174",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7772",
  "graphql": "static-1.78",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3464",
  "persist-promise": "static-1.3556",
  "reporting-client-types": "static-1.2392",
  "foundations-components-legacy": "static-1.643",
  "hs-story-utils": "static-1.9274",
  "react-flip-move": "static-1.66",
  "hub-http-shared-msw-handlers": "static-1.9586",
  "hubspotter-http": "static-1.4522",
  "sassPrefix": "static-1.152",
  "conversations-skeleton-state": "static-1.7096",
  "crm-message-bus": "static-1.42503",
  "customer-data-filters-ui-msw-helpers": "static-1.21506",
  "customer-data-objects-ui-components": "static-1.12860",
  "customer-data-reference-ui-components": "static-1.12996",
  "customer-data-ui-utilities": "static-1.9672",
  "framework-builder-read-service-client": "static-1.3877",
  "framework-data-schema-quick-fetch": "static-1.6626",
  "framework-data-schema-resolvers": "static-1.6721",
  "inbound-db-properties-service-client": "static-1.3715",
  "multi-account-reference-resolvers": "static-1.823",
  "onboarding-tours": "static-1.16333",
  "reporting-datasets-permissions-lib": "static-1.13193",
  "ui-addon-teams": "static-1.21305",
  "apollo-stack-hubspot": "static-3.82",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67766",
  "customer-data-properties": "static-1.50916",
  "forms-ai-lib": "static-1.4078",
  "forms-utils-lib": "static-1.12258",
  "foundations-components-test-utils": "static-1.5101",
  "react-dnd-compat": "static-1.4468",
  "react-tinymce": "static-1.54752",
  "tinymce-config": "static-2.53878",
  "ui-gdpr-components": "static-1.10195",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3887",
  "floating-ui": "static-1.52",
  "react-aria": "static-1.62",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1344",
  "ui-fonts": "static-1.551",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.807",
  "mobile-manifest-mixins": "static-1.497",
  "module-federation": "static-1.19",
  "quartz-head": "static-1.462",
  "quartz-i18n": "static-1.472",
  "quartz-routing": "static-1.227",
  "quartz-test": "static-1.472",
  "quartz-tracking": "static-1.176",
  "batch-promise": "static-1.1399",
  "external-options-client-types": "static-1.4028",
  "react-colorpicker": "static-2.10059",
  "copilot-toolkit": "static-1.10654",
  "data-quality-ui-library": "static-1.12435",
  "html-to-image": "static-1.50",
  "markdown-it": "static-1.6",
  "onboarding-scopes": "static-1.6311",
  "reporting-action-components": "static-1.40776",
  "reporting-insights-lib": "static-1.1217",
  "reporting-plugins": "static-1.10038",
  "ui-addon-draggable-compat": "static-2.4102",
  "ui-addon-opt": "static-4.8231",
  "ui-shepherd-react": "static-3.9994",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24860",
  "hubspot-apollo-client": "static-1.4727",
  "sales-templates-service-types-lib": "static-1.4036",
  "merchandise-lib": "static-1.261",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5544",
  "salesImages": "static-1.521",
  "ts-schema": "static-1.3949",
  "timezone-utils": "static-2.5092",
  "bender-build-tools": "static-1.2992",
  "chatspot-core": "static-1.20524",
  "chirp-fetch": "static-1.1731",
  "bend-plugin-foundations-theming": "static-1.2743",
  "stylex": "static-1.28",
  "hubspotter-http-shared-msw-handlers": "static-1.9584",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3667",
  "crm-pipelines-api-client-types": "static-1.4009",
  "multi-currency-client-types": "static-1.3560",
  "getting-started-shared-tasks": "static-1.18012",
  "growth-data-modal": "static-1.5206",
  "growth-onboarding-confetti": "static-1.2920",
  "growth-onboarding-next-action-utils": "static-1.1418",
  "navigation-components": "static-1.17428",
  "onboarding-tours-client": "static-1.4547",
  "onboarding-tours-utils": "static-1.399",
  "ui-shepherd-tracker": "static-1.7375",
  "ui-universal-auth": "static-1.8765",
  "user-context": "static-1.4948",
  "cms-field-types": "static-1.4657",
  "content-icons-ui": "static-1.2173",
  "integrations-lib": "static-1.15576",
  "calling-global-api": "static-1.63849",
  "calling-internal-common": "static-1.31147",
  "calling-lifecycle-internal": "static-1.65231",
  "calling-lifecycle-messages": "static-1.57525",
  "commerce-products-lib": "static-1.8980",
  "crm-links": "static-1.6116",
  "file-manager-components": "static-1.23041",
  "google-libphonenumber": "static-1.34",
  "hs-entities": "static-1.531",
  "inbounddb-objects-service-types": "static-1.4092",
  "meetings-icalendar-utils-lib": "static-1.480",
  "object-builder-ui-client": "static-1.48155",
  "pipeline-validation-client-types": "static-1.3833",
  "property-value-citations": "static-1.1530",
  "pulse": "static-1.369",
  "smart-property-lib": "static-1.6118",
  "tiered-pricing": "static-1.900",
  "ui-addon-iframeable": "static-1.8895",
  "final-form": "static-1.66",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19552",
  "tinymce-themes": "static-1.55848",
  "data-token-picker": "static-1.16123",
  "hub-http-contrib": "static-1.2891",
  "interframe": "static-3.4617",
  "tinymce-data": "static-1.39963",
  "tinymce-plugins": "static-1.56992",
  "ui-addon-sales-email": "static-1.5062",
  "magpie-lib": "static-1.5442",
  "magpie-types": "static-1.4902",
  "simple-logging-lib": "static-1.2898",
  "content-assistance-lib": "static-1.7518",
  "dashboard-lib": "static-1.80822",
  "ExportDialog": "static-6.10235",
  "hubspot-prosemirror": "static-1.17732",
  "hubspot-prosemirror-plugins": "static-1.17724",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8541",
  "campaign-roi-lib": "static-1.8424",
  "feedback-loader": "static-1.28960",
  "apollo-link-hub-http": "static-2.4499",
  "hubspot-apollo-cache": "static-1.186",
  "growth-monetization-service-types": "static-1.4347",
  "nav-client-types": "static-1.2205",
  "purchase-motions-api": "static-1.5547",
  "trials-service-types": "static-1.3748",
  "growth-onboarding-next-action-components": "static-1.1446",
  "user-context-client": "static-1.4477",
  "idb-keyval": "static-1.40",
  "reactive-lib": "static-1.573",
  "unified-auth-core-lib": "static-1.560",
  "getting-started-shared-tasks-store": "static-1.17130",
  "integrations-error-boundary-lib": "static-1.12991",
  "integrations-tracking-lib": "static-1.5438",
  "native-integrations-shared-strings": "static-1.7635",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10221",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31153",
  "shared-worker-versioning": "static-1.10887",
  "calling-usage-tracker": "static-1.6389",
  "voice-sms-access-library": "static-1.384",
  "customer-data-tracking": "static-1.6730",
  "commerce-permissions": "static-1.611",
  "products-iframe-lib": "static-1.7455",
  "products-ui-components-shared-msw-handlers": "static-1.9968",
  "location-customization-utils-lib": "static-1.8714",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.4002",
  "video-components-external": "static-1.10704",
  "video-data-lib": "static-1.34362",
  "directed-graph": "static-1.787",
  "event-emitter": "static-1.795",
  "fast-json-patch": "static-1.59",
  "breeze-intelligence-kit": "static-1.5392",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9669",
  "fsm": "static-1.3578",
  "policy-lib": "static-1.6625",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9732",
  "navigation-messaging": "static-1.6755",
  "FileManagerLib": "static-1.38681",
  "NamespacedHubStyle": "static-2.8940",
  "FileManagerCore": "static-1.38540",
  "codemirror": "static-5.91",
  "layout-dnd-components": "static-1.12130",
  "layout-dnd-utils": "static-1.11105",
  "react-codemirror": "static-1.10474",
  "ui-addon-emoji-picker": "static-1.9735",
  "ui-brand-identity-lib": "static-1.14222",
  "ui-addon-video-player": "static-1.8544",
  "ui-coaching-tips": "static-1.28068",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8409",
  "payment-link-components": "static-1.23063",
  "EmailSignatureEditor": "static-1.23983",
  "eligibility-engine-service-types": "static-1.3029",
  "universal-page-editor-lib": "static-1.2849",
  "calling-orchestration-schema": "static-1.35161",
  "sales-views-client-types": "static-1.4134",
  "crm-record-cards-service-types": "static-1.3486",
  "content-media-composition-data-lib": "static-1.11629",
  "content-media-compositions": "static-2.15636",
  "media-bridge-lib": "static-1.18645",
  "trellis-story-utils": "static-1.4368",
  "storybook-react": "static-1.29",
  "audio-components": "static-1.5682",
  "FileManagerImages": "static-1.36192",
  "video-components": "static-1.12707",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4379",
  "video-embed": "static-1.35196",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67841",
  "layout-data-lib": "static-1.9430",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6429",
  "commerce-tours-lib": "static-1.5790",
  "growth-onboarding-reliability": "static-1.4934",
  "sales-checkout-service-client": "static-1.3515",
  "draft-convert": "static-2.69",
  "draft-extend": "static-3.71",
  "draft-js": "static-5.74",
  "draft-plugins": "static-2.21388",
  "sales-email-signature-service-client": "static-1.3691",
  "hls.js": "static-1.35",
  "social-insights-client-types": "static-1.21505",
  "outpost": "static-1.4048",
  "advanced-menus-core": "static-1.14887",
  "advanced-menus-lib": "static-1.11856",
  "ui-memberships-settings-lib": "static-1.33575",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14886",
  "simple-menus-lib": "static-1.16403"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34077",
  "client-types": "/client-types/static-1.451",
  "documents-lib": "/documents-lib/static-1.34082",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1976",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4884",
  "highcharts": "/highcharts/static-8.100",
  "hs-promise-utils": "/hs-promise-utils/static-1.5441",
  "hs-test-utils": "/hs-test-utils/static-1.7854",
  "hub-http": "/hub-http/static-1.6065",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "HubStyleTokens": "/HubStyleTokens/static-2.11289",
  "I18n": "/I18n/static-7.1584",
  "jasmine-immutable": "/jasmine-immutable/static-1.2865",
  "jasmine-runner": "/jasmine-runner/static-1.6318",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6797",
  "react": "/react/static-7.182",
  "react-dlb": "/react-dlb/static-1.74",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.67",
  "react-rhumb": "/react-rhumb/static-1.16498",
  "reporting-data": "/reporting-data/static-1.66720",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8653",
  "reporting-visualizations": "/reporting-visualizations/static-1.58796",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4615",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4918",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2340",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.749",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39071",
  "customer-data-objects": "/customer-data-objects/static-1.7499",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7928",
  "data-fetching-client": "/data-fetching-client/static-1.9525",
  "enviro": "/enviro/static-4.416",
  "FireAlarmUi": "/FireAlarmUi/static-1.4377",
  "flux-actions": "/flux-actions/static-1.315",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85403",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4569",
  "foundations-components": "/foundations-components/static-1.7618",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyle": "/HubStyle/static-2.11597",
  "icons": "/icons/static-2.629",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7007",
  "metrics-js": "/metrics-js/static-1.9436",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "property-description-translator": "/property-description-translator/static-1.3704",
  "property-translator": "/property-translator/static-1.5258",
  "quartz-config": "/quartz-config/static-1.575",
  "quartz-core": "/quartz-core/static-1.6016",
  "quick-fetch": "/quick-fetch/static-1.3782",
  "raven": "/raven/static-3.5768",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5218",
  "react-virtualized": "/react-virtualized/static-2.95",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8011",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7931",
  "report-customization-components": "/report-customization-components/static-1.12645",
  "reporting-enablement": "/reporting-enablement/static-1.22245",
  "reporting-reports": "/reporting-reports/static-1.66398",
  "reporting-snowflake": "/reporting-snowflake/static-1.55338",
  "reporting-ui-components": "/reporting-ui-components/static-2.63991",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4486",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8783",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8974",
  "sanitize": "/sanitize/static-1.4322",
  "sanitize-text": "/sanitize-text/static-1.7993",
  "self-service-api": "/self-service-api/static-1.10090",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1599",
  "signup-constants": "/signup-constants/static-1.18511",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20521",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7882",
  "styled-components": "/styled-components/static-2.85",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "superstore": "/superstore/static-1.4617",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10841",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10992",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9393",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17724",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10773",
  "ui-images": "/ui-images/static-2.1109",
  "UIComponents": "/UIComponents/static-3.8236",
  "usage-tracker": "/usage-tracker/static-1.7183",
  "usage-tracker-container": "/usage-tracker-container/static-1.7173",
  "usage-tracker-core": "/usage-tracker-core/static-1.7033",
  "usage-tracker-public": "/usage-tracker-public/static-1.6994",
  "viral-links-lib": "/viral-links-lib/static-1.6886",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3274",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3074",
  "quartz-webpack": "/quartz-webpack/static-1.3021",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8485",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "foundations-assets": "/foundations-assets/static-1.4687",
  "foundations-theming": "/foundations-theming/static-1.4260",
  "quartz-auth": "/quartz-auth/static-1.472",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8880",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4869",
  "foundations-theming-base": "/foundations-theming-base/static-1.3245",
  "HeadJS": "/HeadJS/static-2.722",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2965",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4174",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7772",
  "graphql": "/graphql/static-1.78",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3464",
  "persist-promise": "/persist-promise/static-1.3556",
  "reporting-client-types": "/reporting-client-types/static-1.2392",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.643",
  "hs-story-utils": "/hs-story-utils/static-1.9274",
  "react-flip-move": "/react-flip-move/static-1.66",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9586",
  "hubspotter-http": "/hubspotter-http/static-1.4522",
  "sassPrefix": "/sassPrefix/static-1.152",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7096",
  "crm-message-bus": "/crm-message-bus/static-1.42503",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21506",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12860",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12996",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9672",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3877",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6626",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6721",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3715",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.823",
  "onboarding-tours": "/onboarding-tours/static-1.16333",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13193",
  "ui-addon-teams": "/ui-addon-teams/static-1.21305",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.82",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67766",
  "customer-data-properties": "/customer-data-properties/static-1.50916",
  "forms-ai-lib": "/forms-ai-lib/static-1.4078",
  "forms-utils-lib": "/forms-utils-lib/static-1.12258",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5101",
  "react-dnd-compat": "/react-dnd-compat/static-1.4468",
  "react-tinymce": "/react-tinymce/static-1.54752",
  "tinymce-config": "/tinymce-config/static-2.53878",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10195",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3887",
  "floating-ui": "/floating-ui/static-1.52",
  "react-aria": "/react-aria/static-1.62",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1344",
  "ui-fonts": "/ui-fonts/static-1.551",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.807",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.497",
  "module-federation": "/module-federation/static-1.19",
  "quartz-head": "/quartz-head/static-1.462",
  "quartz-i18n": "/quartz-i18n/static-1.472",
  "quartz-routing": "/quartz-routing/static-1.227",
  "quartz-test": "/quartz-test/static-1.472",
  "quartz-tracking": "/quartz-tracking/static-1.176",
  "batch-promise": "/batch-promise/static-1.1399",
  "external-options-client-types": "/external-options-client-types/static-1.4028",
  "react-colorpicker": "/react-colorpicker/static-2.10059",
  "copilot-toolkit": "/copilot-toolkit/static-1.10654",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12435",
  "html-to-image": "/html-to-image/static-1.50",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-scopes": "/onboarding-scopes/static-1.6311",
  "reporting-action-components": "/reporting-action-components/static-1.40776",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1217",
  "reporting-plugins": "/reporting-plugins/static-1.10038",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4102",
  "ui-addon-opt": "/ui-addon-opt/static-4.8231",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9994",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24860",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4727",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4036",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5544",
  "salesImages": "/salesImages/static-1.521",
  "ts-schema": "/ts-schema/static-1.3949",
  "timezone-utils": "/timezone-utils/static-2.5092",
  "bender-build-tools": "/bender-build-tools/static-1.2992",
  "chatspot-core": "/chatspot-core/static-1.20524",
  "chirp-fetch": "/chirp-fetch/static-1.1731",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2743",
  "stylex": "/stylex/static-1.28",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9584",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3667",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4009",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3560",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18012",
  "growth-data-modal": "/growth-data-modal/static-1.5206",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2920",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1418",
  "navigation-components": "/navigation-components/static-1.17428",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4547",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.399",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7375",
  "ui-universal-auth": "/ui-universal-auth/static-1.8765",
  "user-context": "/user-context/static-1.4948",
  "cms-field-types": "/cms-field-types/static-1.4657",
  "content-icons-ui": "/content-icons-ui/static-1.2173",
  "integrations-lib": "/integrations-lib/static-1.15576",
  "calling-global-api": "/calling-global-api/static-1.63849",
  "calling-internal-common": "/calling-internal-common/static-1.31147",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65231",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57525",
  "commerce-products-lib": "/commerce-products-lib/static-1.8980",
  "crm-links": "/crm-links/static-1.6116",
  "file-manager-components": "/file-manager-components/static-1.23041",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "hs-entities": "/hs-entities/static-1.531",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4092",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.480",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48155",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3833",
  "property-value-citations": "/property-value-citations/static-1.1530",
  "pulse": "/pulse/static-1.369",
  "smart-property-lib": "/smart-property-lib/static-1.6118",
  "tiered-pricing": "/tiered-pricing/static-1.900",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8895",
  "final-form": "/final-form/static-1.66",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19552",
  "tinymce-themes": "/tinymce-themes/static-1.55848",
  "data-token-picker": "/data-token-picker/static-1.16123",
  "hub-http-contrib": "/hub-http-contrib/static-1.2891",
  "interframe": "/interframe/static-3.4617",
  "tinymce-data": "/tinymce-data/static-1.39963",
  "tinymce-plugins": "/tinymce-plugins/static-1.56992",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5062",
  "magpie-lib": "/magpie-lib/static-1.5442",
  "magpie-types": "/magpie-types/static-1.4902",
  "simple-logging-lib": "/simple-logging-lib/static-1.2898",
  "content-assistance-lib": "/content-assistance-lib/static-1.7518",
  "dashboard-lib": "/dashboard-lib/static-1.80822",
  "ExportDialog": "/ExportDialog/static-6.10235",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17732",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17724",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8541",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8424",
  "feedback-loader": "/feedback-loader/static-1.28960",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4499",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.186",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4347",
  "nav-client-types": "/nav-client-types/static-1.2205",
  "purchase-motions-api": "/purchase-motions-api/static-1.5547",
  "trials-service-types": "/trials-service-types/static-1.3748",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1446",
  "user-context-client": "/user-context-client/static-1.4477",
  "idb-keyval": "/idb-keyval/static-1.40",
  "reactive-lib": "/reactive-lib/static-1.573",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.560",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17130",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12991",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5438",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7635",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10221",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31153",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10887",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6389",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.384",
  "customer-data-tracking": "/customer-data-tracking/static-1.6730",
  "commerce-permissions": "/commerce-permissions/static-1.611",
  "products-iframe-lib": "/products-iframe-lib/static-1.7455",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9968",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8714",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.4002",
  "video-components-external": "/video-components-external/static-1.10704",
  "video-data-lib": "/video-data-lib/static-1.34362",
  "directed-graph": "/directed-graph/static-1.787",
  "event-emitter": "/event-emitter/static-1.795",
  "fast-json-patch": "/fast-json-patch/static-1.59",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5392",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9669",
  "fsm": "/fsm/static-1.3578",
  "policy-lib": "/policy-lib/static-1.6625",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9732",
  "navigation-messaging": "/navigation-messaging/static-1.6755",
  "FileManagerLib": "/FileManagerLib/static-1.38681",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8940",
  "FileManagerCore": "/FileManagerCore/static-1.38540",
  "codemirror": "/codemirror/static-5.91",
  "layout-dnd-components": "/layout-dnd-components/static-1.12130",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11105",
  "react-codemirror": "/react-codemirror/static-1.10474",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9735",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14222",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8544",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28068",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8409",
  "payment-link-components": "/payment-link-components/static-1.23063",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23983",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3029",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2849",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35161",
  "sales-views-client-types": "/sales-views-client-types/static-1.4134",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3486",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11629",
  "content-media-compositions": "/content-media-compositions/static-2.15636",
  "media-bridge-lib": "/media-bridge-lib/static-1.18645",
  "trellis-story-utils": "/trellis-story-utils/static-1.4368",
  "storybook-react": "/storybook-react/static-1.29",
  "audio-components": "/audio-components/static-1.5682",
  "FileManagerImages": "/FileManagerImages/static-1.36192",
  "video-components": "/video-components/static-1.12707",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4379",
  "video-embed": "/video-embed/static-1.35196",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67841",
  "layout-data-lib": "/layout-data-lib/static-1.9430",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6429",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5790",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4934",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3515",
  "draft-convert": "/draft-convert/static-2.69",
  "draft-extend": "/draft-extend/static-3.71",
  "draft-js": "/draft-js/static-5.74",
  "draft-plugins": "/draft-plugins/static-2.21388",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3691",
  "hls.js": "/hls.js/static-1.35",
  "social-insights-client-types": "/social-insights-client-types/static-1.21505",
  "outpost": "/outpost/static-1.4048",
  "advanced-menus-core": "/advanced-menus-core/static-1.14887",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11856",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33575",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14886",
  "simple-menus-lib": "/simple-menus-lib/static-1.16403"
}
};
